/* eslint-disable no-undef */
import React from 'react';
import '../../QC/createBatch.css';
//import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SelectDropDown from '../../common/ReactHookForm/SelectDropDown';
import useMutateDGPlateCreate from '../../Hooks/AutoDG/useMutateDGPlateCreate';

import Spinner from '../../common/Spinner';
import { useForm } from 'react-hook-form';
import { consumables, autoDGPlateTypes, mastermix, project, dgOil, drOil, thermo_cycler } from '../../constants/autoDG';


const CreateAutoDGPlate = ({ row, onClose }) => {
    const { plate_uuid, filename } = row;
    // const [startDate, setStartDate] = useState(new Date());
    const { register, handleSubmit, reset, setError, clearErrors, formState, errors } = useForm();
    const createDGPlateAddMutation = useMutateDGPlateCreate();

    const onSubmit = async (data) => {
        // if (startDate) {
        //     clearErrors("Upload Date");
        // } else {
        //     setError("Upload Date", {
        //         type: "manual",
        //         message: "Date is required"
        //     });
        //     return;
        // }

        // Format startDate to 'YYYYMMDD'
        // const year = startDate.getFullYear();
        // const month = String(startDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
        // const day = String(startDate.getDate()).padStart(2, '0');
        // data["Upload Date"] = `${year}${month}${day}`;


        // Map form field names to API field names
        const apiData = {
            consumable: data?.Consumable,
            project: data?.Project,
            master_mix: data?.MasterMix,
            dg_oil: data["DG Oil"],
            dr_oil: data["DR Oil"],
            thermo_cycler: data["Thermal Cycler"],
            plate_type: data["Plate Type"],
            // upload_date: data["Upload Date"],
            operator: data.Operator,
            //  adg_serial_number: serialnumber,
            filename: filename,
            plate_uuid: plate_uuid

        };
        createDGPlateAddMutation.mutate({ apiData },
            {
                onSuccess: (response) => {
                    reset();
                    onClose();
                    // setStartDate(new Date());
                },
                onError: (error) => {
                    console.log(error);
                    reset();
                    onClose();
                }
            }
        );
    }
    return (
        <>

            <div className='grid place-items-center'>
                <h1 className="text-center pt-10 pb-6 font-extrabold text-custom-green">Create DG Plate</h1>
                <div className='border-2 border-[rgba(9,185,123,0.348)] rounded-[20px] shadow-[3px_4px_0px_1px_#049343]'>
                    <h2 className="text-left pt-10 px-4 font-extrabold">Currenlty Tracked Fields</h2>
                    <form className='grid grid-cols-2 gap-4  place-items-start p-4 text-center' onSubmit={handleSubmit(onSubmit)}>

                        <label className='w-32 pt-3 font-semibold text-left'>Consumable</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md "
                            {...register("Consumable", { required: true })} options={consumables} name="Consumable" />


                        <label className='w-32 pt-3 font-semibold text-left'>Operator</label>
                        <input className="w-full custom-inset-shadow  border border-gray-300 px-4 py-2 rounded-md"
                            {...register("Operator", { required: true })} />


                        <label className='w-32 pt-3 font-semibold text-left'>Plate Type</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("Plate Type", { required: true })} options={autoDGPlateTypes} name="Plate Type" />


                        <label className='w-32 pt-3 font-semibold text-left'>DG Oil</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("DG Oil", { required: true })} options={dgOil} name="DG Oil" />


                        <label className='w-32 pt-3 font-semibold text-left'>DR Oil</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("DR Oil", { required: true })} options={drOil} name="DR Oil" />


                        <label className='w-32 pt-3 font-semibold text-left'>MasterMix</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("MasterMix", { required: true })} options={mastermix} name="MasterMix" />


                        <label className='w-32 pt-3 font-semibold text-left'>Project</label>

                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("Project", { required: true })} options={project} name="Project" />


                        <label className='w-32 pt-3 font-semibold text-left'>Thermal Cycler</label>
                        <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                            {...register("Thermal Cycler", { required: true })} options={thermo_cycler} name="Thermal Cycler" />



                        {/* comment out per Alvin for now
                        <label className="w-32 pt-3 font-semibold text-left">Upload Date</label>
                        <DatePicker className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md w-full "
                            selected={startDate} onChange={(date) => setStartDate(date)} /> */}


                        <button className={`text-white px-4 py-2 rounded  flex justify-center items-center shadow-md 
                        ${formState.isDirty && formState.isValid ? "bg-green-700" : 'bg-gray-400 cursor-not-allowed'}`}
                            type="submit" disabled={!(formState.isDirty && formState.isValid)}>Create Plate</button>
                        {/* <button className="text-black px-4 py-2 text-center border border-gray-300 rounded-md " type="reset">Cancel</button> */}

                        {createDGPlateAddMutation.isLoading &&
                            <div className="backdrop center-child">
                                <Spinner text="Creating Plate.." />
                            </div>
                        }
                    </form>

                </div>


            </div >

        </>
    )

}

export default CreateAutoDGPlate;